import React from "react";
import Button from "../../../ui/Button/Button";
import Container from "../../../ui/Container/Container";
import "./InitialPatientAgreement.css";

function InitialPatientAgreement({ onOptionChosen }) {
  return (
    <Container title="Nuevo paciente" backNavigation="/mainDoctor">
      <div className="initialPatientAgreement">
        <div style={{
          backgroundColor: "#FF2600",
          padding: "10px",
          margin: "10px"
        }}>
          <p style={{
            color: "white", fontSize: "16px"
          }}>
            Estimado doctor(a) por favor solicite a su paciente aceptar el
            siguiente Aviso de Privacidad.
          </p>
        </div>
        <p className="ipa_mainTitle">Aviso de Privacidad</p>
        <p className="ipa_p">Estimado Paciente</p>
        <p className="ipa_p">
          Por medio del presente se le informa que el Aviso de Privacidad ha sido realizado en apego a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, su Reglamento y a los Lineamientos Generales en Materia de Protección de Datos Personales (“las disposiciones legales”).
        </p>
        <p className="ipa_p">Hacemos de su conocimiento lo siguiente:</p>
        <p className="ipa_title">
          Responsable(s) del tratamiento de datos personales:
        </p>
        <p className="ipa_p">
          Las empresas Exeltis Pharma México, S.A. de C.V. y Atrare Consultores S. de R.L. de C.V. (conjuntamente referidos como <span className="ipa_bold">“Los Responsables”</span>), serán las responsables del tratamiento y resguardo de los datos personales que nos proporcione mediante esta aplicación (App) y Sitio web, los cuales serán protegidos conforme a lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
        </p>
        <p className="ipa_title">
          Aceptación del aviso de privacidad y consentimiento de los Titulares:
        </p>
        <p className="ipa_p">
          Al hacer entrega de sus datos personales por cualquier medio, ya sea electrónico o físico, los Titulares aceptan y otorgan su consentimiento a <span className="bold">Los Responsables</span> y sus empresas filiales y/o subsidiarias a utilizar y tratar de forma automatizada sus datos personales e información suministrados, los cuales pasarán a formar parte de las bases de datos de <span className="bold">Los Responsables</span> y de las empresas filiales y/o subsidiarias correspondientes.
        </p>
        <p className="ipa_title">Datos personales sujetos al tratamiento:</p>
        <p className="ipa_p">
          Los datos personales que serán recabados conforme a lo establecido en el presente aviso de privacidad serán los siguientes:
        </p>
        <p className="ipa_p">
          •	Datos de identificación. A saber: Iniciales del paciente, edad y género.
        </p>
        <p className="ipa_p">
          •	Datos de contacto. A saber: nombre, domicilio, teléfono, correo electrónico (solo en caso de reporte de efectos secundarios).
        </p>
        <p className="ipa_p">
          •	Información relacionada con su estado de salud y con información médica sensible. A saber: diagnóstico, antecedente heredofamiliar, enfermedades concomitantes, medicamentos concomitantes y cualquier otra información relacionada con los medicamentos y tratamientos del paciente.
        </p>
        <p className="ipa_p">
          Sus datos personales no se vincularán directamente con la información de uso de nuestro producto, ya que usted quedará registrado con un código de identificación.
        </p>
        <p className="ipa_title">
          Finalidades del tratamiento:
        </p>
        <p className="ipa_p">
          Los datos personales serán utilizados para las siguientes finalidades:
        </p>
        <p className="ipa_p">•	Mantener registro de los perfiles creados en la App y Sitio web.</p>
        <p className="ipa_p">•	Para proporcionar información a los pacientes sobre recomendaciones de uso del Suplemento alimenticio a base de SPM´s, Omega 3, Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina.</p>
        <p className="ipa_p">•	Para llevar una relación y control sobre el uso y administración del Suplemento Alimenticio en los Pacientes.</p>
        <p className="ipa_p">•	Para generar un perfil de los Pacientes.</p>
        <p className="ipa_p">•	Para solicitar información adicional en caso de presentar efectos secundarios.</p>
        <p className="ipa_p">•	Para que, en su caso, puedan consultar su historial de uso y administración del Suplemento Alimenticio.</p>
        <p className="ipa_p">•	Enviar correos promocionales o informativos sobre otros productos o servicios ofrecidos por <span className="bold">Los Responsables.</span></p>
        <p className="ipa_p">•	Para temas relacionados con servicio al cliente y encuestas de satisfacción.</p>
        <p className="ipa_title">
          Resguardo y conservación de los datos personales:
        </p>
        <p className="ipa_p">
          Se hace del conocimiento de los Pacientes que sus datos personales podrán ser incluidos en una base de datos y serán tratados, según el grupo de interés respectivo, para las finalidades anteriormente previstas.
        </p>
        <p className="ipa_p">
          Tratándose de Datos Personales Sensibles, <span className="bold">Los Responsables</span> se comprometen a tomar las medidas que resulten necesarias y suficientes para proteger la confidencialidad de dichos datos y a tratarlos únicamente para las finalidades legítimas, concretas y acordes con los fines explícitos para los cuales son recabados por <span className="bold">Los Responsables.</span> Solo se crearán bases de Datos Personales Sensibles en caso de ser estrictamente necesario.
        </p>
        <p className="ipa_p">
          En caso de que los Pacientes no estén de acuerdo con el uso de sus datos personales para una o varias de las finalidades anteriores, podrán solicitar la limitación del uso de sus datos personales, para lo cual deberán enviar un correo electrónico a la siguiente dirección: contacto@atrareconsultores.com.mx.
        </p>
        <p className="ipa_title">
          Transferencia de datos personales: 
        </p>
        <p className="ipa_p">
          Sus datos personales podrán ser remitidos o transferidos a empresas filiales o del grupo comerciales de <span className="bold">Los Responsables</span> conforme a los supuestos permitidos por las disposiciones legales en materia de protección de datos personales o en los demás supuestos establecidos por la legislación aplicable. 
        </p>
        <p className="ipa_p">
          Para obtener mayor información relacionada con la remisión o transmisión de sus datos personales, lo invitamos a contactarnos a través del correo electrónico mencionado en el presente Aviso de Privacidad.
        </p>
        <p className="ipa_title">
          Medios para el ejercicio de sus derechos ARCO o para revocar su consentimiento:
        </p>
        <p className="ipa_p">
          Usted tiene derecho a conocer con qué datos contamos, para qué los utilizamos y las condiciones del uso que les daremos (acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (cancelación); así como oponerse al uso de sus datos personales para fines específicos (oposición). Estos derechos se conocen como derechos ARCO.
        </p>
        <p className="ipa_p">
          Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través del siguiente medio:
        </p>
        <span>Correo electrónico y/o presentación de forma escrita o personal.</span><br/>
        <span>contacto@atrareconsultores.com.mx</span><br/>
        <span>Privada Miguel Ángel #2, Col. Nonoalco, C.P. 03700, Benito Juárez, CDMX</span><br/>
        <span>Teléfono: +52 55 5611 6250</span><br/>
        <p className="ipa_p">
          Para mayor detalle sobre el uso de la información y acerca de los Derechos ARCO, usted puede ingresar a los portales de nuestras empresas. https://www.exeltis.com.mx/aviso.html y http://atrare.com.mx/aviso-de-privacidad#anchor3.
        </p>
        <p className="ipa_title">
          Medidas de seguridad: 
        </p>
        <p className="ipa_p">
          Los datos personales serán mantenidos en la más estricta confidencialidad y serán resguardados de manera adecuada.
        </p>
        <p className="ipa_p">
          Para ello <span className="bold">Los Responsables</span> han implementado y mantienen las medidas de seguridad, técnicas, administrativas y físicas necesarias para proteger sus datos personales y evitar su pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizado.
        </p>
        <p className="ipa_title">
          Cambios a este Aviso de Privacidad: 
        </p>
        <p className="ipa_p">
          Cualquier cambio o actualización a este Aviso de Privacidad serán publicados a través de nuestra página web o a través del correo electrónico que nos haya proporcionado.
        </p>
        <p className="ipa_title">
          Consentimiento para el tratamiento de datos personales: 
        </p>
        <p className="ipa_p">
          Para efectos de lo dispuesto en las disposiciones legales en materia de protección de datos personales, <span className="bold">el Paciente</span> manifiesta lo siguiente:
        </p>
        <p className="ipa_p">•	que otorga su consentimiento para la recolección, tratamiento y uso de sus datos personales desde el momento en que los ha proporcionado por primera vez hasta la conclusión de su relación con <span className="bold">Los Responsables;</span></p>
        <p className="ipa_p">•	que el presente Aviso le ha sido dado a conocer por <span className="bold">Los Responsables;</span> y</p>
        <p className="ipa_p">•	que ha leído, entendido y aceptado los términos expuestos en este Aviso de Privacidad para la recolección, obtención, almacenamiento, divulgación, transferencia, tratamiento y uso de sus datos personales.</p>
        <div className="ipa_buttons">
          <div style={{ width: "40%" }}>
            <Button onPress={onOptionChosen.bind(this, true)}>Acepto</Button>
          </div>
          <div style={{ width: "40%" }}>
            <Button onPress={onOptionChosen.bind(this, false)}>No acepto</Button>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default InitialPatientAgreement;
